import { render, staticRenderFns } from "./intelCenter.vue?vue&type=template&id=4c01a739"
import script from "./intelCenter.vue?vue&type=script&lang=js"
export * from "./intelCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports